import React from 'react';
import PropTypes from 'prop-types';
import GoogleTranslateWidget from '../../01_atoms/GoogleTranslateWidget';
import FormattedText from '../../01_atoms/FormattedText';
import SSLIcon from '../../../public/static/icons/ssl-icon.svg';
import RecaptchaIcon from '../../../public/static/icons/recaptcha-icon.svg';

const DonationFormFooter = ({
  columnOneHeader = '',
  columnOneContent = '',
  columnTwoHeader = '',
  columnTwoContent = '',
  text = '',
  images = [],
  googleTranslateEnabled = false,
}) => {
  return (
    <>
      <div className="container">
        {images.length > 0 && (
          <div className="payment-logos">
            {images.map((image) => (
              <img
                key={image.url}
                src={image.url}
                alt={image.alt}
                loading="lazy"
                width={60}
                height={54}
              />
            ))}
          </div>
        )}
      </div>

      <div className="donation-form-footer-info">
        <div className="container">
          <div className="donation-form-footer-contact">
            {columnOneHeader && <h3>{columnOneHeader}</h3>}
            {columnOneContent && <FormattedText text={columnOneContent} />}
            <div className="donation-form-footer-line"></div>
          </div>
          <div className="donation-form-footer-privacy">
            {columnTwoHeader && <h3>{columnTwoHeader}</h3>}
            {columnTwoContent && <FormattedText text={columnTwoContent} />}
            <RecaptchaIcon />
            <SSLIcon />
          </div>
        </div>
      </div>

      <div className="donation-form-footer-legal">
        <div className="container">
          {googleTranslateEnabled && <GoogleTranslateWidget />}
          {text && <FormattedText className="payment-copy" text={text} />}
        </div>
      </div>
    </>
  );
};

DonationFormFooter.propTypes = {
  columnOneHeader: PropTypes.string,
  columnOneContent: PropTypes.string,
  columnTwoHeader: PropTypes.string,
  columnTwoContent: PropTypes.string,
  text: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      alt: PropTypes.string,
    }),
  ),
  googleTranslateEnabled: PropTypes.bool,
};

export default DonationFormFooter;
